import { useTranslation } from 'react-i18next';

export default function OperatingCosts() {
  const { t } = useTranslation();

  const costs = [
    { label: t('costs_water'), amount: t('costs_water_amount') },
    { label: t('costs_internet'), amount: t('costs_internet_amount') },
    { label: t('costs_electricity_consumed'), amount: t('costs_electricity_consumed_amount') },
    { label: t('costs_gas'), amount: t('costs_gas_amount') },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('costs_title')}
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left Column - Text Content */}
          <div className="space-y-8">
            <p className="text-lg text-gray-700 leading-relaxed">
              {t('costs_intro')}
            </p>

            {/* Annual Operating Costs */}
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                {t('costs_annual_title')}
              </h3>
              
              <div className="space-y-3">
                {costs.map((cost, idx) => (
                  <div key={idx} className="flex justify-between items-center py-3 border-b border-gray-200">
                    <span className="text-gray-700 font-medium">{cost.label}</span>
                    <span className="text-gray-900 font-semibold">{cost.amount}</span>
                  </div>
                ))}
                
                <div className="flex justify-between items-center py-3 border-b border-gray-300">
                  <span className="text-gray-900 font-bold">{t('costs_total_utilities')}</span>
                  <span className="text-gray-900 font-bold">{t('costs_total_utilities_amount')}</span>
                </div>

                <div className="flex justify-between items-center py-3 border-b border-gray-200">
                  <span className="text-gray-700 font-medium">{t('costs_electricity_sold')}</span>
                  <span className="text-green-600 font-semibold">{t('costs_electricity_sold_amount')}</span>
                </div>

                <div className="flex justify-between items-center py-3 border-b border-gray-200">
                  <span className="text-gray-700 font-medium">{t('costs_waste_tax')}</span>
                  <span className="text-gray-900 font-semibold">{t('costs_waste_tax_amount')}</span>
                </div>

                {/* Highlighted Net Annual Cost */}
                <div className="bg-gray-900 text-white rounded-lg p-6 mt-6">
                  <div className="flex justify-between items-center">
                    <span className="text-xl font-bold">{t('costs_net_annual')}</span>
                    <span className="text-3xl font-bold">{t('costs_net_annual_amount')}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Comfort and Climate Control */}
            <div className="bg-gray-50 rounded-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {t('costs_comfort_title')}
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-gray-900 text-xl mt-1 mr-3"></i>
                  <span className="text-gray-700">{t('costs_comfort_pool')}</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-gray-900 text-xl mt-1 mr-3"></i>
                  <span className="text-gray-700">{t('costs_comfort_home')}</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Right Column - Image Placeholder */}
          <div className="lg:sticky lg:top-24">
            <div className="bg-gray-100 rounded-2xl overflow-hidden shadow-lg">
              <div className="w-full h-full">
                <img
                  src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/f191f5a4d5a47ff35fd21e59f521e427.jpeg"
                  alt={t('costs_image_caption')}
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
